export const reservationsStatusLabels = {
  sr: "Sin reserva",
  nn: "No necesita",
  res: "Reservado",
  pag: "Pagado",
  wtf: "WTF",
}

export const reservationsLabels = {
  status : "el *estado*",
  baseImponible : "la *base imponible*",
  finalPrice : "el *precio total*",
  supplier : "el *proveedor*",
  receipt : "el *numero de factura*",
  receiptDate : "la *fecha de factura*",
  iva0: "el *IVA 0%*",
  iva10: "el *IVA 10%*",
  iva21: "el *IVA 21%*",
  iva4: "el *IVA 4%*",
}

const undefinedTreatmentAux = {
  status : "Sin reserva",
  baseImponible : 0,
  finalPrice : 0,
  supplier : "Sin proveedor",
  receipt : "Sin numero",
  receiptDate : "Sin fecha",
  iva0: 0,
  iva10: 0,
  iva21: 0,
  iva4: 0,
}

export function undefinedTreatment(value, keyChange) {
  let treat = value
  if (!value) {
    treat = undefinedTreatmentAux[keyChange]
  }
  return treat
}


const ivaByType = {
  hotel: 10, 
  expense: 21, 
  activity: 21, 
  city: 10,
  default: 21
}

export const getIva = r => (ivaByType[r.expenseType || r.type] || ivaByType.default)

const estimatedPrice = (final, r) => (final / (1 + (getIva(r) / 100)))

export const getBI = r => (Number(r.baseImponible) || estimatedPrice(r.finalPrice || 0, r)) //If r.baseImponible isn't a number because reasons, we'll take the estimated price

